import axiosInstance, { silentRequest } from "../utils/axiosConfig";
import {
  AttendanceUpdateRequest,
  AttendanceUpdateRequestsResponse,
} from "../types/attendanceUpdateRequest";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE = `${backendUrl}/api/attendance-update-requests`;

// ── Query params shared by list endpoints ────────────────────────────────────
export interface FetchRequestsParams {
  status?: "pending" | "approved" | "rejected" | "all";
  page?: number;
  limit?: number;
}

// ── Manager / SuperAdmin — all requests (scoped by role on the backend) ──────
export const fetchUpdateRequests = (params: FetchRequestsParams = {}) =>
  axiosInstance.get<AttendanceUpdateRequestsResponse>(BASE, { params });

// ── Single request detail ────────────────────────────────────────────────────
export const fetchUpdateRequestById = (id: string) =>
  axiosInstance.get<{ success: boolean; request: AttendanceUpdateRequest }>(
    `${BASE}/${id}`,
  );

// ── HR — requests the logged-in user submitted ───────────────────────────────
export const fetchMyRequests = (params: FetchRequestsParams = {}) =>
  axiosInstance.get<AttendanceUpdateRequestsResponse>(`${BASE}/my-requests`, {
    params,
  });

// ── Approve a request (Manager / SuperAdmin) ─────────────────────────────────
export const approveUpdateRequest = (id: string, reviewRemarks?: string) =>
  axiosInstance.patch(`${BASE}/${id}/approve`, { reviewRemarks });

// ── Reject a request (Manager / SuperAdmin) ──────────────────────────────────
export const rejectUpdateRequest = (id: string, reviewRemarks?: string) =>
  axiosInstance.patch(`${BASE}/${id}/reject`, { reviewRemarks });

// ── Silent poll — returns 0 on any error (used for header badge) ─────────────
export const fetchPendingCount = async (): Promise<number> => {
  try {
    const { data } = await silentRequest.get<AttendanceUpdateRequestsResponse>(
      `${BASE}`,
      { params: { status: "pending", limit: 1, page: 1 } },
    );
    return data?.totalRecords ?? 0;
  } catch {
    return 0;
  }
};
